import { List, Kanban, BarChart2, CalendarRange, Image } from 'lucide-react';
import { CheckCircle2, TrendingUp, Clock, PauseCircle } from 'lucide-react';

// Status color map (for ProjectDetail tabs)
export const STATUS_CFG = {
  on_planning:      { label: 'On Planning',       color: '#64748b', bg: '#f1f5f9' },
  on_progress:      { label: 'On Progress',       color: '#6366f1', bg: '#ede9fe' },
  waiting_approval: { label: 'Waiting Approval',  color: '#8b5cf6', bg: '#f5f3ff' },
  on_hold:          { label: 'On Hold',           color: '#ef4444', bg: '#fef2f2' },
  done:             { label: 'Done',              color: '#10b981', bg: '#f0fdf4' },
};

// Tab definitions
export const TABS = [
  { id: 'list',     label: 'List',                icon: List         },
  { id: 'board',    label: 'Kanban Board',        icon: Kanban       },
  { id: 'actual',   label: 'Aktual Gantt Chart',  icon: BarChart2    },
  { id: 'schedule', label: 'Schedule Gantt Chart', icon: CalendarRange },
  { id: 'media',    label: 'Media',               icon: Image        },
];

// Status config for ProjectList (includes icon components)
export const listStatusConfig = {
  Selesai:   { label: 'Selesai',      color: '#10b981', bg: '#f0fdf4', icon: CheckCircle2 },
  Berlangsung: { label: 'Berlangsung',  color: '#6366f1', bg: '#ede9fe', icon: TrendingUp   },
  Menunggu:     { label: 'Menunggu',     color: '#f59e0b', bg: '#fffbeb', icon: Clock         },
};
